import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';

import { DesignerConnection } from 'dibs-buyer-layout/exports/DesignerConnection';
import { trackDesignerConnectionMessageClose } from 'dibs-buyer-layout/exports/designerConnectionTracking';

import styles from './DesignerConnectionFolderConfirmationModal.scss';

export function DesignerConnectionFolderConfirmationModal(props) {
    const { isOpen, itemTitle, onClose, portfolioName } = props;
    let title = <span className={styles.itemTitle}>{itemTitle}</span>;
    if (!itemTitle) {
        title = (
            <span>
                <FormattedMessage
                    id="abf.FavoritesIcons.DesignerConnectionFolderModal.itemTitle"
                    defaultMessage="Your item"
                />
            </span>
        );
    }
    return (
        <ModalContainer isOpen={isOpen} onClose={onClose} modalPosition="center">
            <ModalCloseButton
                onClick={() => {
                    trackDesignerConnectionMessageClose();
                    onClose();
                }}
            />
            <BarHeader
                title={
                    <FormattedMessage
                        id="DesignerConnectionFolderConfirmationModal.title"
                        defaultMessage="Added to Folder"
                    />
                }
            />
            <ModalBody className={styles.body}>
                <FormattedMessage
                    id="DesignerConnectionFolderConfirmationModal.confirmationMessage"
                    defaultMessage="{itemTitle} has been added to {portfolioName}"
                    values={{
                        itemTitle: title,
                        portfolioName: (
                            <span className={styles.portfolioName}>{portfolioName}</span>
                        ),
                    }}
                />
                <div className={styles.designerConnectionWrapper}>
                    <DesignerConnection />
                </div>
            </ModalBody>
        </ModalContainer>
    );
}

DesignerConnectionFolderConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    itemTitle: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    portfolioName: PropTypes.string,
};
